import { ReactElement } from 'react'
import { useLocation } from 'react-router-dom'
import useLogout from 'ui/customHooks/useLogout'
import { redirectTo } from 'ui/customHooks/useHistory'
import i18n from 'lang/i18n'
import routePaths from 'const/routePaths'
import { noOperations } from 'helpers'
import { noop } from 'lodash'
import { SessionProps } from './typing'
import {
  ContinueSessionButton,
  HeaderText,
  LoginAgainButton,
  PrimaryText,
  SecondaryText,
  SessionExpiredContainer,
  SessionTimeOutContent,
  TextWrapper
} from './subcomponents'

const SessionExpired = ({
  isSessionExpired,
  loginHandler = noop,
  continueSessionHandler = noOperations
}: SessionProps): ReactElement => {
  const { pathname } = useLocation()
  const logout = useLogout()
  const isAppSessionExpired = pathname === routePaths.sessionExpired
  const isExpired = isSessionExpired || isAppSessionExpired

  const handleBackToLogin = () => {
    logout()
    loginHandler()
    redirectTo(routePaths.home)
  }

  return (
    <SessionExpiredContainer isExpired={isAppSessionExpired}>
      {isAppSessionExpired && (
        <HeaderText>{i18n({ sessionExpired: 'sessionTimeout' })}</HeaderText>
      )}
      <SessionTimeOutContent>
        <TextWrapper>
          <PrimaryText>
            {i18n(
              { sessionExpired: 'accountInactivity' },
              { isSessionExpired }
            )}
          </PrimaryText>
          <SecondaryText>
            {isExpired
              ? 'Please log in again to continue working.'
              : 'If you are still working, please click Continue Session below.'}
          </SecondaryText>
        </TextWrapper>
        {isExpired ? (
          <LoginAgainButton buttonType="secondary" onClick={handleBackToLogin}>
            {i18n({ button: 'logInAgain' })}
          </LoginAgainButton>
        ) : (
          <ContinueSessionButton
            buttonType="primary"
            onClick={continueSessionHandler}
          >
            {i18n({ button: 'continueSession' })}
          </ContinueSessionButton>
        )}
      </SessionTimeOutContent>
    </SessionExpiredContainer>
  )
}

export default SessionExpired
